import { Col, Modal, Row, Spin, Tooltip } from 'antd'

import Flex from 'components/Flex'
import React, { useEffect, useRef, useState } from 'react'
import { COLORS } from 'theme'
import { useNavigate } from 'react-router-dom'
import { FlexWrap } from '../../../components/UIComponents/FormStyles'
import AlarmIcon from '../../../components/icons/AlarmIcon'
import CalendarIcon from '../../../components/icons/CalendarIcon'
import CandidatesIcon from '../../../components/icons/CandidatesIcon'
import ClockIcon from '../../../components/icons/ClockIcon'
import Location from '../../../components/icons/Location'
import PaymentsIcon from '../../../components/icons/PaymentsIcon'
import ToolsIcon from '../../../components/icons/ToolsIcon'
import { formatAMPM } from '../../../modules/JobPreview/constant'
import { dateConversion } from '../../../utils/rolecreationHelpers'
import { AndDivision, Atag, ShowDiv, SubtitleSmall, TextContent } from './style'

import {
  ExtraPadding,
  SubBold,
} from 'components/UIComponents/CloseRolePopup/style.js'
import { formatNumber } from 'utils/formatNumber'
import DuplicateIcon from '../../../assets/icons/DuplicateIcon'
import EditIcon from '../../../assets/icons/EditIcon'
import { EditorContent } from '../../../components/RichEditor/ContentStyles'
import {
  AdjustIcon,
  StyledCardDiv,
  StyledDelete,
  StyledH2,
  StyledImg,
} from '../../../components/Uploader/Styles'
import FileIcon from '../../../components/icons/FileIcon'
import DownArrowIcon from '../../../components/icons/JobRoleIcons/DownArrowIcon'
import ApprovedModelIcon from '../../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import {
  AnswerText,
  ButtonDiv,
  Condition,
  IconAlign,
  JobSchedule,
  JobSubTitle,
  JobTitle,
  LIElement,
  ScoreContainer,
  SkillBox,
  SpacingWrapper,
  TextContainer,
  TextHeading,
  TextWithIcon,
  TimeDateDivision,
  TimeIcon,
  TimeInfo,
  TimeLabel,
  ULElement,
} from '../../../modules/JobPreview/style'
import { FolderSpinner } from '../../../modules/Placement/style'
import ErrorMessage from '../../../utils/ErrorMessage'
import SuccessMessage from '../../../utils/SuccessMessage'
import CloseRoleDrawer from '../CloseRolePopup'
import { EmptyDivElement } from '../CommonStyledComponent'
import { CompensationText, CompensationBreakup, CompensationType, } from './style'
const { confirm } = Modal

const PreviewPage = ({
  previewData,
  isLoading,
  duplicateRole,
  forPreviewPage = false,
  accessLevel,
  onActionsClick,
  onEditClick,
  getRoleData,
  jobId,
}) => {
  const contentHeight = useRef(null)
  const scrollRef = useRef(null)
  const [scoreType, setScoreType] = useState('average')
  const [showAll, setShowAll] = useState(false)
  const [isDuplicateLoading, setIsDuplicateLoading] = useState(false)
  const isDuplicatingRef = useRef(false)

  const editHandler = () => {
    if (onEditClick) {
      onEditClick(previewData?.id, previewData?.status, previewData)
    } else {
      // Fallback to original behavior if onEditClick is not provided
      if (previewData?.isEditable == false) {
        return
      } else {
        navigate(`/roles/edit-role/${previewData?.id}`)
      }
    }
  }

  const totalIntegrations = previewData?.eligibilityCriteria?.reduce(
    (count, item) => {
      return (
        count +
        item?.qualification?.reduce((subCount, qual) => {
          return (
            subCount +
            item?.selected?.[qual]?.reduce((subSubCount, subitem) => {
              return subitem.isAllDegree
                ? subSubCount
                : subSubCount +
                (subitem?.streams?.reduce((streamCount, stream) => {
                  return (
                    streamCount + (stream?.specialisations?.length || 1)
                  )
                }, 0) || 1)
            }, 0)
          )
        }, 0)
      )
    },
    0
  )
  const navigate = useNavigate()
  const showItemCount = showAll ? totalIntegrations : 5

  let displayedIntegrations = 0

  useEffect(() => {
    if (previewData) {
      const { avgScore } = previewData
      if (avgScore != 0 && avgScore) {
        setScoreType('average')
      } else {
        setScoreType('Custom')
      }
    }
  }, [previewData])
  const downloadFileLocal = async file => {
    try {
      const fileUrl = file.fileUrl || file.fileURL || file.url;
      const fileName = file.fileName || file.name;

      if (!fileUrl) {
        console.error('No file URL found:', file);
        return;
      }

      const response = await fetch(fileUrl)
      if (!response.ok) {
        throw new Error('Failed to download file')
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName || 'download'
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  const startDate = previewData?.startDate
  const endDate = previewData?.endDate
  const startDateFormatted = dateConversion({
    date: startDate,
    convertTo: 'Date/Month/Year',
  })
  const endDateFormatted = dateConversion({
    date: endDate,
    convertTo: 'Date/Month/Year',
  })
  const groupedEducations = Array.isArray(previewData?.degreeStreamMap)
    ? previewData?.degreeStreamMap?.reduce((acc, education) => {
      const degreeShortForm = education?.degree?.shortForm
      const streamName = education?.stream?.name

      if (!acc.hasOwnProperty(degreeShortForm)) {
        acc[degreeShortForm] = []
      }

      acc[degreeShortForm].push(streamName)

      return acc
    }, {})
    : []

  const renderContent = () => {
    let content = []

    if (groupedEducations) {
      Object.entries(groupedEducations).forEach(([degree, streamNames]) => {
        content.push(
          <ExtraPadding key={degree}>
            <SubBold>{degree}</SubBold>
            <br />
            {streamNames.join(', ')}
            <br />
          </ExtraPadding>
        )
      })
    }

    return content
  }

  const [expanded, setExpanded] = useState(true)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  const handleCapitalize = value => {
    if (value) {
      let word = value.split(' ')

      for (let i = 0; i < word.length; i++) {
        word[i] = word[i].charAt(0).toUpperCase() + word[i].slice(1)
      }
      return word.join(' ') + ' - '
    }
  }

  const handleDuplicateRole = async (jobId) => {
    if (isDuplicatingRef.current) return;

    const modal = confirm({
      title: 'Duplicate Role?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',

      onOk: async () => {
        if (isDuplicatingRef.current) return;

        isDuplicatingRef.current = true;

        // 🔥 ADD THIS (loading + disable button)
        modal.update({
          okButtonProps: { loading: true },
          cancelButtonProps: { disabled: true },
        });

        try {
          const response = await duplicateRole(jobId);

          if (response?.status >= 200 && response?.status < 300) {
            navigate(`/rolePage`);
            getRoleData();
          }
        } catch (error) {
          console.error('Error duplicating role:', error);
        } finally {
          isDuplicatingRef.current = false;

          // optional (modal usually closes automatically)
          modal.update({
            okButtonProps: { loading: false },
            cancelButtonProps: { disabled: false },
          });
        }
      },
    });
  };

  const [showEntendRolePopup, setShowEntendRolePopup] = useState(false)
  const handleEditRole = () => {
    setShowEntendRolePopup(true)
  }
  const handleCloseClick = () => {
    setShowEntendRolePopup(false)
  }
  const handleApproveClick = () => {
    setShowEntendRolePopup(false)
    navigate(`/jobRoles/editRole/${previewData?.id}`)
  }

  useEffect(() => {
    setTimeout(() => {
      if (contentHeight.current && contentHeight.current.clientHeight > 250) {
        setExpanded(false)
      }
    }, 3000)
  }, [])
  function ensureAbsoluteURL(url) {
    if (!url.match(/^https?:\/\//)) {
      return 'https://' + url
    }
    return url
  }
  const splitDate = () => {
    let date = {
      minYear: '0',
      maxYear: '0',
      minMonth: '0',
      maxMonth: '0',
    }
    if (previewData?.yearOfExperience?.length > 1) {
      let min = String(previewData?.yearOfExperience?.[0])?.split('.')
      let max = String(previewData?.yearOfExperience?.[1])?.split('.')
      if (min?.length) {
        date.minYear = min?.[0] ?? 0
        date.minMonth = min?.[1] ?? 0
      }
      if (max?.length) {
        date.maxYear = max?.[0] ?? 0
        date.maxMonth = max?.[1] ?? 0
      }
    }
    return date
  }
  const date = splitDate()

  useEffect(() => {
    {
      !forPreviewPage &&
        scrollRef.current?.scrollIntoView({ behavior: 'smooth', top: 0 })
    }
  }, [])

  return (
    <>
      {isLoading ? (
        <FolderSpinner>
          <Spin />
        </FolderSpinner>
      ) : (
        <>
          <div ref={scrollRef}></div>

          <div style={{ display: 'flex', gap: '30px' }}>
            <JobTitle>{previewData?.tittle ?? ''}</JobTitle>
            {forPreviewPage && !previewData?.isArchived && (
              <div style={{ display: 'flex', gap: '10px' }}>
                {
                  <EmptyDivElement
                    style={{ cursor: 'pointer' }}
                    onClick={editHandler}
                  >
                    <Tooltip title="Edit Role">
                      <EditIcon
                        style={{ marginRight: '10px', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  </EmptyDivElement>
                }

                {
                  <div
                    onClick={() => handleDuplicateRole(jobId)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Tooltip title="Duplicate">
                      <DuplicateIcon />
                    </Tooltip>
                  </div>
                }
              </div>
            )}
          </div>
          <SpacingWrapper top="20px" bottom="20px">
            <FlexWrap gap="10px" centerVertically>
              <TextContainer>
                <AlarmIcon />
                <JobSchedule color={COLORS.GREY_T_30} weight={600}>
                  {previewData?.jobType === 'PART_TIME'
                    ? 'Part Time'
                    : previewData?.jobType === 'FULL_TIME'
                      ? 'Full Time'
                      : ''}
                  {previewData?.employmentType &&
                    '(' +
                    (previewData?.employmentType === 'CONTRACT'
                      ? 'Off Roll/Contractual'
                      : previewData?.employmentType === 'ONROLL'
                        ? 'On Roll'
                        : '') +
                    ')'}
                </JobSchedule>
              </TextContainer>

              <SubtitleSmall color={COLORS.GREY_T_80} marginbottom="0">
                |
              </SubtitleSmall>

              <TextContainer>
                <CandidatesIcon />
                <JobSchedule color={COLORS.GREY_T_30} weight={600}>
                  {previewData?.jobTypeLevels?.[0] == 'ENTRY' ||
                    previewData?.jobTypeLevels?.[0] == 'INTERN'
                    ? 'Freshers'
                    : previewData?.jobTypeLevels?.[0] == 'BOTH'
                      ? 'Both'
                      : previewData?.jobTypeLevels?.[0] == 'EXPERIENCED'
                        ? 'Experienced'
                        : ''}

                  {(previewData?.jobCategory == 'APPRENTICESHIP' ||
                    previewData?.jobCategory == 'PLACEMENT' ||
                    previewData?.jobCategory == 'GIGS' ||
                    previewData?.jobCategory == 'INTERNSHIP') &&
                    previewData?.jobTypeLevels?.[0] != 'INTERN' &&
                    previewData?.jobTypeLevels?.[0] != 'ENTRY' ? (
                    <>
                      {' '}
                      <>
                        {'( ' +
                          (date?.minYear +
                            (Number(date?.minYear) <= 1
                              ? 'yr   '
                              : ' yrs   ')) +
                          (date?.minMonth + 'mos   ')}
                        {previewData?.yearOfExperience?.[1] &&
                          '-' +
                          (date?.maxYear +
                            (Number(date?.maxYear) <= 1
                              ? 'yr  '
                              : ' yrs  ')) +
                          date?.maxMonth +
                          'mos )'}
                      </>
                    </>
                  ) : (
                    ''
                  )}
                </JobSchedule>
              </TextContainer>
              <TextContainer>
                {(() => {
                  const shouldShowNoStipend = previewData?.minCompensation == 0 &&
                    previewData?.maxCompensation == 0 &&
                    previewData?.stipend === true;

                  return shouldShowNoStipend;
                })() ? (
                  <>
                    {previewData?.jobCategory === 'GIGS' ||
                      previewData?.jobCategory == 'PLACEMENT' ? (
                      ''
                    ) : (
                      <>
                        <SubtitleSmall
                          color={COLORS.GREY_T_80}
                          marginbottom="0"
                        >
                          |
                        </SubtitleSmall>
                        <PaymentsIcon />
                      </>
                    )}
                    <JobSchedule weight={600}>
                      {previewData?.jobCategory === 'GIGS' ||
                        previewData?.jobCategory == 'PLACEMENT'
                        ? ''
                        : 'No Stipend'}
                    </JobSchedule>
                  </>
                ) : (
                  <>
                    <SubtitleSmall color={COLORS.GREY_T_80} marginbottom="0">
                      |
                    </SubtitleSmall>
                    <PaymentsIcon />

                    <JobSchedule weight={600} color={COLORS.GREY_T_10}>
                      {(previewData?.CTCPeriod === 'MONTHLY' ||
                        (previewData?.jobCategory === 'INTERNSHIP' &&
                          previewData?.rolePublishedBy === 'INSTITUTE')) &&
                        previewData?.minCompensation !== 0
                        ? 'Monthly - '
                        : handleCapitalize(previewData?.CTCPeriod)}
                      {(() => {
                        const getCompensationText = () => {
                          const min = Number(previewData?.minCompensation)
                          const max = Number(previewData?.maxCompensation)

                          if (min === max) {
                            return `₹ ${formatNumber(min)}`
                          }

                          if (min && max) {
                            return `₹ ${formatNumber(min)} - ₹ ${formatNumber(max)}`
                          }

                          return `₹ ${formatNumber(max || min)}`
                        }
                        // Free-text value — render as-is, no numeric parsing.
                        const variable = previewData?.variableAmount;
                        const hasVariable =
                          variable !== null &&
                          variable !== undefined &&
                          `${variable}`.trim() !== '';
                        if (previewData?.ctcType === 'FIXED_VARIABLE') {
                          return (
                            <>
                              <CompensationText>
                                {getCompensationText()}
                                <CompensationBreakup>
                                  (Fixed+Variable)
                                </CompensationBreakup>
                              </CompensationText>
                            </>
                          )
                        }
                        return (
                          <>
                            <CompensationText>
                              {getCompensationText()}
                            </CompensationText>
                            <CompensationType>(Fixed)</CompensationType>
                          </>
                        )
                      })()}

                      {previewData?.jobCategory === 'INTERNSHIP' &&
                        Number(previewData?.internshipDuration) &&
                        Number(previewData?.internshipDuration) !== 0
                        ? ' (' +
                        (previewData?.jobCategory === 'INTERNSHIP'
                          ? `${Number(previewData?.internshipDuration) >= 30
                            ? (Number(previewData?.internshipDuration) / 30) % 1 === 0
                              ? `${Number(previewData?.internshipDuration) / 30} Month${Number(previewData?.internshipDuration) / 30 === 1
                                ? ''
                                : 's'
                              }`
                              : `${(Number(previewData?.internshipDuration) / 30).toFixed(1)} Month${(Number(previewData?.internshipDuration) / 30).toFixed(1) === '1.0'
                                ? ''
                                : 's'
                              }`
                            : `${Number(previewData?.internshipDuration)} Day${Number(previewData?.internshipDuration) === 1 ? '' : 's'
                            }`
                          }`
                          : '') +
                        ') '
                        : ''}

                      {previewData?.isBond === true && '  Bond'}
                    </JobSchedule>
                  </>
                )}
              </TextContainer>
            </FlexWrap>
          </SpacingWrapper>
          <Row>
            <Col>
              {previewData?.jobCategory === 'GIGS' &&
                previewData?.gigsDuration &&
                (previewData?.gigsDuration[0] || previewData?.gigsDuration[1]) && (
                  <>
                    <TextHeading mBottom={'5px'}>Duration</TextHeading>
                    <TextHeading mBottom={'10px'} size={'16px'} color="#343E59" weight={'400'}>
                      {previewData?.gigsDuration[0] && `${previewData.gigsDuration[0]} Yrs`}
                      {previewData?.gigsDuration[0] && previewData?.gigsDuration[1] && ' - '}
                      {previewData?.gigsDuration[1] && `${previewData.gigsDuration[1]} Yrs`}
                    </TextHeading>
                  </>
                )}

              {previewData?.company?.companyName?.length > 0 && (
                <>
                  <TextHeading mBottom={'5px'}>Company Name</TextHeading>
                  <TextHeading mBottom={'10px'} size={'24px'} color="#343E59">
                    {previewData?.company?.companyName}
                  </TextHeading>
                </>
              )}
              {previewData?.company?.website?.length > 0 && (
                <>
                  <TextHeading mBottom={'5px'}>Company Website</TextHeading>
                  <Tooltip title={` ${previewData?.company?.website}`}>
                    <TextHeading
                      mBottom={'10px'}
                      size={'16px'}
                      color="#3249D7"
                      style={{
                        textWrap: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textTransform: 'initial',
                        width: '350px',
                      }}
                    >
                      <Atag
                        href={ensureAbsoluteURL(previewData?.company?.website)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {previewData?.company?.website}
                      </Atag>
                    </TextHeading>
                  </Tooltip>
                </>
              )}

              {previewData?.company?.sector?.length > 0 && (
                <>
                  <TextHeading mBottom={'5px'}>Company Sector</TextHeading>
                  <TextHeading weight={'400'}>
                    {previewData?.company?.sector}
                  </TextHeading>
                </>
              )}
              {previewData?.company?.description?.length > 0 && (
                <FlexWrap margintop="10px" flexDirection={true}>
                  <TextHeading mBottom={'5px'}>About the company</TextHeading>
                  <TextHeading
                    size={'15px'}
                    weight={'400'}
                    dark
                    style={{
                      overflowWrap: 'anywhere',
                    }}
                  >
                    <div
                      style={{ paddingRight: '15px' }}
                      dangerouslySetInnerHTML={{
                        __html: previewData?.company?.description,
                      }}
                    ></div>
                  </TextHeading>
                </FlexWrap>
              )}
              {previewData?.externalLink?.length > 0 && (
                <>
                  <TextHeading mBottom={'5px'}>Job Application Link</TextHeading>
                  <Tooltip title={` ${previewData?.externalLink}`}>
                    <TextHeading
                      mBottom={'10px'}
                      size={'16px'}
                      color="#3249D7"
                      style={{
                        textWrap: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textTransform: 'initial',
                        width: '350px',
                      }}
                    >
                      <Atag
                        href={ensureAbsoluteURL(previewData?.externalLink)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {previewData?.externalLink}
                      </Atag>
                    </TextHeading>
                  </Tooltip>
                </>
              )}

            </Col>
          </Row>
          <FlexWrap gap="15px" centerVertically margintop="10px">
            <TimeInfo>
              <FlexWrap gap="5px" centerVertically>
                <TimeIcon>
                  <CalendarIcon color="#6EE3F3" />
                </TimeIcon>
                <SubtitleSmall marginbottom="0" capitalize={true}>
                  <TimeDateDivision>
                    <TimeLabel title>Start date-End Date</TimeLabel>
                    <TimeLabel color={COLORS.GREY_T_30}>
                      {startDate === endDate
                        ? startDateFormatted
                        : `${startDateFormatted} - ${endDateFormatted}`}
                    </TimeLabel>
                  </TimeDateDivision>
                </SubtitleSmall>
              </FlexWrap>
            </TimeInfo>

            <TimeInfo>
              <FlexWrap gap="5px" centerVertically>
                <TimeIcon>
                  <ClockIcon color="#6EE3F3" />
                </TimeIcon>
                <SubtitleSmall marginbottom="0" capitalize={true}>
                  <TimeDateDivision>
                    <TimeLabel title>End Time</TimeLabel>
                    <TimeLabel color={COLORS.GREY_T_30}>
                      {formatAMPM(new Date(previewData?.endDate))}
                    </TimeLabel>
                  </TimeDateDivision>
                </SubtitleSmall>
              </FlexWrap>
            </TimeInfo>
          </FlexWrap>

          {previewData?.jobRoleDocs?.filter(item => {
            const fileName = item?.fileName || item?.name;
            const fileUrl = item?.fileUrl || item?.fileURL || item?.url;
            return item && fileName && fileUrl &&
              fileName.trim() !== '' && fileUrl.trim() !== '';
          })?.length > 0 && (

              <FlexWrap gap="10px" margintop="20px" width="77%">
                {previewData?.jobRoleDocs?.filter(item => {
                  const fileName = item?.fileName || item?.name;
                  const fileUrl = item?.fileUrl || item?.fileURL || item?.url;
                  return item && fileName && fileUrl &&
                    fileName.trim() !== '' && fileUrl.trim() !== '';
                })?.map((item, key) => (
                  <StyledCardDiv key={key + 'role'}>
                    <StyledImg>
                      <AdjustIcon alignContent>
                        <FileIcon />
                      </AdjustIcon>
                      <Flex gap="5px">
                        <StyledH2>{item?.fileName}</StyledH2>
                        <StyledH2>{item?.fileSize}</StyledH2>
                      </Flex>
                    </StyledImg>
                    <Flex>
                      <StyledDelete>
                        <ButtonDiv>
                          <DownArrowIcon
                            onClick={() => downloadFileLocal(item)}
                          />
                        </ButtonDiv>
                      </StyledDelete>
                    </Flex>
                  </StyledCardDiv>
                ))}
              </FlexWrap>
            )}

          {previewData?.cities?.length > 0 || previewData?.isAnyWhere ? (
            <Row>
              <Col md={24}>
                <SpacingWrapper top={'20px'} bottom={'10px'}>
                  <TextWithIcon>
                    <IconAlign>{Location()}</IconAlign>
                    {previewData?.isAnyWhere ? (
                      <AnswerText
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <JobSubTitle>Job Location : </JobSubTitle>{' '}
                        <div style={{ marginTop: 2 }}> Any Where </div>
                      </AnswerText>
                    ) : (
                      <JobSubTitle>Job Location </JobSubTitle>
                    )}
                  </TextWithIcon>
                </SpacingWrapper>
              </Col>

              {previewData?.cities?.map((item, key) => (
                <Col
                  md={9}
                  key={key + item?.name ?? item?.city_name ?? item?.state_name}
                >
                  <ULElement>
                    <LIElement
                      color
                      key={
                        key + item?.name ?? item?.city_name ?? item?.state_name
                      }
                    >
                      {item.name ?? item?.city_name ?? item?.state_name}
                    </LIElement>
                  </ULElement>
                </Col>
              ))}
            </Row>
          ) : null}
          <Row>
            <Col md={24}>
              <TextContainer mTop={'0px'}>
                <AnswerText fontWeight="600">Work style : </AnswerText>
                <AnswerText fontWeight="600">
                  {previewData?.workStyle === 'REMOTE'
                    ? 'Remote'
                    : previewData?.workStyle === 'ONSITE'
                      ? 'Onsite'
                      : previewData?.workStyle === 'HYBRID'
                        ? 'Hybrid'
                        : ''}
                </AnswerText>
              </TextContainer>
            </Col>
            <Col md={24}>
              {previewData?.additionalBenefits?.length > 0 && (
                <>
                  <TextHeading mTop={'10px'}>
                    Additional Benefits :{' '}
                  </TextHeading>
                  <AnswerText
                    style={{ marginTop: '1em', wordBreak: 'break-word' }}
                    dangerouslySetInnerHTML={{
                      __html: previewData?.additionalBenefits,
                    }}
                  ></AnswerText>
                </>
              )}
            </Col>
            <Col md={24}>
              {previewData?.bondType?.length > 0 && (
                <>
                  <TextHeading>Bond Details </TextHeading>
                  <EditorContent
                    dangerouslySetInnerHTML={{
                      __html: previewData?.bondType,
                    }}
                  />
                </>
              )}
            </Col>
            <Col md={24}>
              <TextHeading mTop={'10px'} mBottom={'5px'}>
                Job Description
              </TextHeading>
              <EditorContent
                style={{ marginTop: '1em', wordBreak: 'break-word' }}
                dangerouslySetInnerHTML={{
                  __html: previewData?.description || '',
                }}
              />
            </Col>

            {(() => {
              const fixed = Number(previewData?.minCompensation || 0);
              const variable = previewData?.variableAmount;
              const hasVariable =
                variable !== null &&
                variable !== undefined &&
                `${variable}`.trim() !== '';

              if (previewData?.ctcType === 'FIXED_VARIABLE' && hasVariable) {
                return (
                  <Col md={24}>
                    <TextHeading mTop="10px" mBottom="5px">
                      Fixed+Variable
                    </TextHeading>
                    <EditorContent
                      style={{ marginTop: '1em', wordBreak: 'break-word' }}
                    >{variable}</EditorContent>
                  </Col>
                );
              }

              return null;
            })()}

          </Row>
          <Row>
            {previewData?.publishTo && (
              <Col xs={24}>
                <TextHeading mTop={'10px'} mBottom={'5px'}>
                  Gender
                </TextHeading>
                <TextContent>
                  {previewData?.publishTo === 'ALL' ? 'All' :
                    previewData?.publishTo === 'MALE' ? 'Male' :
                      previewData?.publishTo === 'FEMALE' ? 'Female' :
                        previewData?.publishTo}
                </TextContent>
              </Col>
            )}
            {previewData?.eligibilityCriteria?.length > 0 && (
              <Col xs={24}>
                <TextWithIcon>
                  {ToolsIcon()}
                  <TextHeading>Eligility Criteria</TextHeading>
                </TextWithIcon>
              </Col>
            )}
            {previewData?.eligibilityCriteria?.length > 0 && (
              <Col xs={24}>
                <TextHeading mBottom={'20px'} mTop={'5px'}>
                  Degree & Departments
                </TextHeading>
                <div>
                  <TextWithIcon wrap="wrap" gap="10px">
                    {previewData?.eligibilityCriteria?.map((item, key) => {
                      if (displayedIntegrations >= showItemCount) return null

                      return (
                        <React.Fragment key={key + 'displayIntegration'}>
                          {item.qualification?.map((qual, index) => (
                            <React.Fragment key={qual + index + 'info'}>
                              {item?.selected?.[qual]?.[0]?.isAllDegree ? (
                                <SkillBox> Any {[qual]}</SkillBox>
                              ) : (
                                <>
                                  {' '}
                                  {item?.selected?.[qual]?.map(
                                    (subitem, subkey) => {
                                      return (
                                        <React.Fragment key={subkey + 'subKey'}>
                                          {subitem?.streams?.map(
                                            (stream, streamIndex) => (
                                              <React.Fragment
                                                key={
                                                  streamIndex + 'streamIndex'
                                                }
                                              >
                                                {stream?.specialisations
                                                  ?.length > 0
                                                  ? stream?.specialisations?.map(
                                                    (spec, specIndex) => {
                                                      if (
                                                        displayedIntegrations >=
                                                        showItemCount
                                                      )
                                                        return null

                                                      displayedIntegrations++
                                                      return (
                                                        <React.Fragment
                                                          key={
                                                            specIndex +
                                                            'specIndex'
                                                          }
                                                        >
                                                          <SkillBox>
                                                            {
                                                              subitem?.shortForm
                                                            }{' '}
                                                            - {stream?.name} -{' '}
                                                            {spec?.name}
                                                          </SkillBox>
                                                          {specIndex <
                                                            stream
                                                              .specialisations
                                                              .length -
                                                            1 &&
                                                            displayedIntegrations <
                                                            showItemCount && (
                                                              <Condition>
                                                                Or
                                                              </Condition>
                                                            )}
                                                        </React.Fragment>
                                                      )
                                                    }
                                                  )
                                                  : displayedIntegrations++ <
                                                  showItemCount && (
                                                    <SkillBox
                                                      key={
                                                        streamIndex +
                                                        'streamIndex'
                                                      }
                                                    >
                                                      {subitem?.shortForm} -{' '}
                                                      {stream?.name}
                                                    </SkillBox>
                                                  )}
                                                {streamIndex <
                                                  subitem.streams.length - 1 &&
                                                  displayedIntegrations <
                                                  showItemCount && (
                                                    <Condition>Or</Condition>
                                                  )}
                                              </React.Fragment>
                                            )
                                          )}
                                          {subitem?.streams?.length === 0 &&
                                            displayedIntegrations++ <
                                            showItemCount && (
                                              <SkillBox key={subkey + 'subKey'}>
                                                {subitem?.shortForm}
                                              </SkillBox>
                                            )}
                                          {subkey <
                                            item?.selected?.[qual]?.length -
                                            1 &&
                                            displayedIntegrations <
                                            showItemCount && (
                                              <Condition>Or</Condition>
                                            )}
                                        </React.Fragment>
                                      )
                                    }
                                  )}
                                </>
                              )}
                              {index < item.qualification.length - 1 && (
                                <Condition>Or</Condition>
                              )}
                            </React.Fragment>
                          ))}
                          {key < previewData.eligibilityCriteria.length - 1 && (
                            <AndDivision>And</AndDivision>
                          )}
                        </React.Fragment>
                      )
                    })}
                    {totalIntegrations > 5 && (
                      <ShowDiv onClick={() => setShowAll(!showAll)}>
                        {showAll ? 'Show Less' : 'Show More'}
                      </ShowDiv>
                    )}
                  </TextWithIcon>
                </div>
              </Col>
            )}
            <Col xs={24} style={{ paddingTop: 10 }}>
              {previewData?.jobRoleSkills?.length > 0 && (
                <>
                  <TextHeading mTop={'10px'}>Skills</TextHeading>
                  <TextWithIcon wrap={'wrap'}>
                    {previewData?.jobRoleSkills?.map((item, index, array) => (
                      <React.Fragment key={item.id}>
                        <SkillBox>{item?.name}</SkillBox>
                      </React.Fragment>
                    ))}
                  </TextWithIcon>
                </>
              )}

              {previewData?.yearOfPassing?.length > 0 && (
                <>
                  <TextHeading mTop={'20px'} mBottom={'5px'}>
                    Year of passing
                  </TextHeading>
                  <TextHeading weight={'400'}>
                    {previewData?.yearOfPassing.join(', ')}
                  </TextHeading>
                </>
              )}

              {((previewData?.tenthScore &&
                previewData?.tenthScore !== '0') ||
                (previewData?.twelfthScore &&
                  previewData?.twelfthScore !== '0') ||
                (previewData?.UGScore &&
                  previewData?.UGScore !== '0') ||
                (previewData?.PGScore &&
                  previewData?.PGScore !== '0') ||
                (previewData?.UGDiplomaScore &&
                  previewData?.UGDiplomaScore !== '0') ||
                (previewData?.PGDiplomaScore &&
                  previewData?.PGDiplomaScore !== '0')) ? (
                <>
                  <TextHeading mTop={'20px'} mBottom={'5px'}>
                    Score (Percentage)
                  </TextHeading>
                  {scoreType === 'average' ? (
                    <TextHeading weight={'400'}>
                      Avg{' '}
                      {previewData?.avgScore > 0
                        ? previewData?.avgScore
                        : previewData?.PGScore > 0
                          ? previewData?.PGScore
                          : previewData?.PGDiplomaScore !== null &&
                            previewData?.PGDiplomaScore > 0
                            ? previewData?.PGDiplomaScore
                            : previewData?.UGScore > 0
                              ? previewData?.UGScore
                              : previewData?.UGDiplomaScore !== null &&
                                previewData?.UGDiplomaScore > 0
                                ? previewData?.UGDiplomaScore
                                : previewData?.twelfthScore > 0
                                  ? previewData?.twelfthScore
                                  : previewData?.tenthScore > 0
                                    ? previewData?.tenthScore
                                    : ''}{' '}
                      %
                      {[
                        previewData?.tenthScore &&
                          previewData?.tenthScore !== '0'
                          ? '10th'
                          : null,
                        previewData?.twelfthScore &&
                          previewData?.twelfthScore !== '0'
                          ? '12th'
                          : null,
                        previewData?.UGScore && previewData?.UGScore !== '0'
                          ? 'UG'
                          : null,
                        previewData?.PGScore && previewData?.PGScore !== '0'
                          ? 'PG'
                          : null,
                        previewData?.UGDiplomaScore &&
                          previewData?.UGDiplomaScore !== '0'
                          ? 'Diploma'
                          : null,
                      ].filter(Boolean).length > 0 && (
                          <>
                            {' ('}
                            {[
                              previewData?.tenthScore &&
                                previewData?.tenthScore !== '0'
                                ? '10th'
                                : null,
                              previewData?.twelfthScore &&
                                previewData?.twelfthScore !== '0'
                                ? '12th'
                                : null,
                              previewData?.UGScore && previewData?.UGScore !== '0'
                                ? 'UG'
                                : null,
                              previewData?.PGScore && previewData?.PGScore !== '0'
                                ? 'PG'
                                : null,
                              previewData?.UGDiplomaScore &&
                                previewData?.UGDiplomaScore !== '0'
                                ? 'Diploma'
                                : null,
                            ]
                              .filter(Boolean)
                              .join(', ')}
                            {') '}
                          </>
                        )}
                    </TextHeading>
                  ) : (
                    <ScoreContainer>
                      <TextHeading weight={'400'}>
                        <TextContainer>
                          {previewData?.tenthScore &&
                            previewData?.tenthScore !== '0' && (
                              <>
                                10th-{previewData?.tenthScore}%
                                {(previewData?.twelfthScore &&
                                  previewData?.twelfthScore !== '0') ||
                                  (previewData?.PGScore &&
                                    previewData?.PGScore !== '0') ||
                                  (previewData?.UGDiplomaScore &&
                                    previewData?.UGDiplomaScore !== '0') ||
                                  (previewData?.UGScore &&
                                    previewData?.UGScore !== '0') ? (
                                  <SubtitleSmall
                                    color={COLORS.GREY_T_80}
                                    marginbottom="0"
                                  >
                                    |
                                  </SubtitleSmall>
                                ) : null}
                              </>
                            )}
                          {previewData?.twelfthScore &&
                            previewData?.twelfthScore !== '0' && (
                              <>
                                12th-{previewData?.twelfthScore}%
                                {(previewData?.UGScore &&
                                  previewData?.UGScore !== '0') ||
                                  (previewData?.PGScore &&
                                    previewData?.PGScore !== '0') ||
                                  (previewData?.UGDiplomaScore &&
                                    previewData?.UGDiplomaScore !== '0') ? (
                                  <SubtitleSmall
                                    color={COLORS.GREY_T_80}
                                    marginbottom="0"
                                  >
                                    |
                                  </SubtitleSmall>
                                ) : null}
                              </>
                            )}
                          {previewData?.UGScore &&
                            previewData?.UGScore !== '0' && (
                              <>
                                UG-{previewData?.UGScore}%
                                {(previewData?.PGScore &&
                                  previewData?.PGScore !== '0') ||
                                  (previewData?.UGDiplomaScore &&
                                    previewData?.UGDiplomaScore !== '0') ? (
                                  <SubtitleSmall
                                    color={COLORS.GREY_T_80}
                                    marginbottom="0"
                                  >
                                    |
                                  </SubtitleSmall>
                                ) : null}
                              </>
                            )}
                          {previewData?.PGScore &&
                            previewData?.PGScore !== '0' && (
                              <>
                                PG-{previewData?.PGScore}%
                                {previewData?.UGDiplomaScore &&
                                  previewData?.UGDiplomaScore !== '0' ? (
                                  <SubtitleSmall
                                    color={COLORS.GREY_T_80}
                                    marginbottom="0"
                                  >
                                    |
                                  </SubtitleSmall>
                                ) : null}
                              </>
                            )}

                          {previewData?.UGDiplomaScore &&
                            previewData?.UGDiplomaScore !== '0' && (
                              <>Diploma-{previewData?.UGDiplomaScore}%</>
                            )}
                        </TextContainer>
                      </TextHeading>
                    </ScoreContainer>
                  )}
                </>
              ) : null}

              <TextHeading mTop={'20px'} mBottom={'5px'}>
                Arrears/Backlogs
              </TextHeading>
              {previewData?.isArrearsAllowed && (
                <>
                  <TextHeading mTop={'10px'} mBottom={'8px'}>
                    Current Arrears
                  </TextHeading>
                  <TextHeading weight={'400'}>
                    Less than or equal to {previewData?.arrearCount}.
                  </TextHeading>
                </>
              )}
              {previewData?.isHistoryArrears && (
                <>
                  <TextHeading mTop={'10px'} mBottom={'8px'}>
                    History of Arrears
                  </TextHeading>

                  <TextHeading weight={'400'}>
                    Less than or equal to {previewData?.historyArrearCount}.
                  </TextHeading>
                </>
              )}

              {!previewData?.isHistoryArrears &&
                !previewData?.isArrearsAllowed && (
                  <TextHeading weight={'400'}>
                    No Arrears / Backlogs allowed
                  </TextHeading>
                )}

              {previewData?.roleFlotedTo?.length > 0 && (
                <>
                  <TextHeading mTop={'20px'} mBottom={'5px'}>
                    If you want to share this role with other students in your
                    college, select degrees to share the role.
                  </TextHeading>
                  <TextHeading weight={'400'}>
                    {' '}
                    {previewData?.roleFlotedTo
                      ?.map(item => item.shortForm)
                      ?.join(', ')}
                  </TextHeading>
                </>
              )}

              {previewData?.applicationFormTemplate &&
                (previewData?.applicationFormTemplate?.mandatoryQuestions?.length > 0 ||
                  previewData?.applicationFormTemplate?.customQuestions?.length > 0) && (
                  <>
                    <TextHeading mTop={'20px'} mBottom={'10px'}>
                      Application Form
                    </TextHeading>

                    {previewData?.applicationFormTemplate?.mandatoryQuestions?.length > 0 && (
                      <>
                        <ULElement>
                          {previewData?.applicationFormTemplate?.mandatoryQuestions?.map((q, idx) => (
                            <LIElement key={`mq-${idx}`} color={true}>
                              {q.question}
                            </LIElement>
                          ))}
                        </ULElement>
                      </>
                    )}

                    {previewData?.applicationFormTemplate?.customQuestions?.length > 0 && (
                      <>
                        <TextHeading mTop={'10px'} mBottom={'5px'}>
                          Application Form - "Custom Questions"
                        </TextHeading>
                        <ULElement>
                          {previewData?.applicationFormTemplate?.customQuestions?.map((q, idx) => (
                            <LIElement key={`cq-${idx}`} color={true}>
                              {q.question}
                            </LIElement>
                          ))}
                        </ULElement>
                      </>
                    )}
                  </>
                )}
            </Col>
          </Row>
          {showEntendRolePopup && (
            <CloseRoleDrawer
              description={
                <>
                  This application has already been edited once. You can now
                  only modify the end date and time.
                </>
              }
              Textdescription={'All other fields will remain locked.'}
              Icon={ApprovedModelIcon}
              showDrawer={showEntendRolePopup}
              setShowDrawer={setShowEntendRolePopup}
              onCloseClick={handleCloseClick}
              onApprove={() => handleApproveClick()}
              closeText={'Back'}
              YesText={'Edit'}
              closeButtonHeight={'38px'}
              closeButtonWidth={'80px'}
              yesButtonHeight={'38px'}
              yesButtonWidth={'105px'}
            />
          )}
        </>
      )}
    </>
  )
}
export default PreviewPage
